export default __webpack_public_path__ + "static/media/sensus-communis-logo-white.e8e8849d.svg";